import { differenceInYears, isPast, parse } from "date-fns";

export interface IParseBirthday {
  age: number;
  birthday: Date;
  sex?: string;
}

export const parseBirthday = (date: Date): IParseBirthday =>
  isValidBirthday(date) && {
    birthday: date,
    age: differenceInYears(new Date(), date)
  };

export const isValidBirthday = (value: string | Date) => {
  const date =
    value instanceof Date ? value : parse(value, "dd.MM.yyyy", new Date());

  if (date instanceof Date && isNaN(date.getTime())) {
    return {
      error: "Neplatné datum"
    };
  }

  if (!isPast(date)) {
    return {
      error: "Datum nesmí být budoucí"
    };
  }

  return true;
};
